// Client-side mirror of the backend NIP check — for instant feedback only; the API validates again.
const WEIGHTS = [6, 5, 7, 2, 3, 4, 5, 6, 7];

/** Digits only, without the "PL" prefix, spaces and dashes. */
export function normalizeNip(value: string): string {
  return value.trim().replace(/^pl/i, "").replace(/[\s-]/g, "");
}

export function isValidNip(value: string): boolean {
  const digits = normalizeNip(value);
  if (!/^\d{10}$/.test(digits)) {
    return false;
  }
  const sum = WEIGHTS.reduce((acc, w, i) => acc + w * Number(digits[i]), 0);
  const check = sum % 11;
  // A remainder of 10 is never issued as a NIP.
  return check !== 10 && check === Number(digits[9]);
}
